import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map, switchMap } from 'rxjs/operators';

import { MainQuery } from '@shared/store/main/main.query';
import { Utils } from '@shared/utils/utils';

import { UserTasksState, UserTasksStore } from './user-tasks.store';

@Injectable({ providedIn: 'root' })
export class UserTasksQuery extends QueryEntity<UserTasksState> {
  private mainQuery = inject(MainQuery);

  protected store: UserTasksStore;

  constructor() {
    const store = inject(UserTasksStore);

    super(store);

    this.store = store;
  }

  getCurrentTrialTasks() {
    return this.mainQuery.select('trialKey').pipe(
      switchMap((trialId) => this.selectAll({ filterBy: (entity) => entity.trial_id === trialId })),
      map((tasks) =>
        tasks.sort((task1, task2) => Utils.dateSort(task1.create_date, task2.create_date))
      )
    );
  }
}
